import { List, useTable } from "@refinedev/antd";
import { Segmented, Space, Table, Tag, Typography } from "antd";
import dayjs from "dayjs";
import { useNavigate } from "react-router";

import { DATE_TIME_FORMAT, PROFILE_CHANGE_FIELDS, PROFILE_CHANGE_STATUS } from "../labels";
import type { ProfileChangeItem } from "../types";

const STATUS_OPTIONS = [
  { value: "PENDING", label: "Bekleyen" },
  { value: "APPROVED", label: "Onaylanan" },
  { value: "REJECTED", label: "Reddedilen" },
  { value: "ALL", label: "Tümü" },
];

/**
 * /profile-changes (permission `tutors.view`; deciding needs `tutors.verify`): approved tutors'
 * photo, profile video, "Hakkımda", name and subject changes, waiting ones oldest first
 * (product decision 2026-10-13).
 */
export function ProfileChangesPage() {
  const navigate = useNavigate();
  const { tableProps, filters, setFilters } = useTable<ProfileChangeItem>({
    resource: "profile-changes",
    pagination: { mode: "server", pageSize: 25 },
    filters: { initial: [{ field: "status", operator: "eq", value: "PENDING" }] },
    syncWithLocation: true,
  });
  const status =
    (filters.find((item) => "field" in item && item.field === "status")?.value as string) ??
    "PENDING";

  return (
    <List title="Profil değişiklikleri">
      <Space wrap style={{ marginBottom: 16 }}>
        <Segmented
          options={STATUS_OPTIONS}
          value={status}
          onChange={(value) =>
            setFilters([{ field: "status", operator: "eq", value: String(value) }], "replace")
          }
        />
      </Space>
      <Table
        {...tableProps}
        rowKey="id"
        scroll={{ x: "max-content" }}
        onRow={(record) => ({
          onClick: () => navigate(`/profile-changes/${record.id}`),
          style: { cursor: "pointer" },
        })}
      >
        <Table.Column<ProfileChangeItem>
          title="Eğitmen"
          key="tutor"
          render={(_, change) => <Typography.Text strong>{change.tutor.name}</Typography.Text>}
        />
        <Table.Column<ProfileChangeItem>
          title="Değişiklik"
          dataIndex="field"
          render={(field: string) => PROFILE_CHANGE_FIELDS[field] ?? field}
        />
        <Table.Column<ProfileChangeItem>
          title="Gönderildi"
          dataIndex="createdAt"
          render={(value: string) => dayjs(value).format(DATE_TIME_FORMAT)}
        />
        <Table.Column<ProfileChangeItem>
          title="Durum"
          dataIndex="status"
          render={(value: string) => (
            <Tag color={PROFILE_CHANGE_STATUS[value]?.color}>
              {PROFILE_CHANGE_STATUS[value]?.label}
            </Tag>
          )}
        />
      </Table>
    </List>
  );
}
